import behaviourConstants from "@/constants/behaviourManagementConstants.js"
import { buildPaginationFromApiResponse } from "@/helpers/behaviourCoreValueApi.js"

/**
 * @param {number | string | null | undefined} perPageValue
 * @returns {boolean}
 */
export function isBehaviourTableLazyLoadingMode(perPageValue) {
  return (
    Number(perPageValue) ===
    behaviourConstants.CORE_VALUE_TABLE_ALL_ENTRIES_PER_PAGE
  )
}

/**
 * @param {number | string | null | undefined} perPageValue
 * @returns {{
 *   isLazyMode: boolean,
 *   perPageVal: number,
 *   requestPerPage: number,
 *   lazyChunkSize: number
 * }}
 */
export function resolveBehaviourTableLazyRequest(perPageValue) {
  const perPageVal = Number(perPageValue) || 25
  const lazyChunkSize = behaviourConstants.CORE_VALUE_TABLE_ALL_ENTRIES_PER_PAGE
  const isLazyMode = isBehaviourTableLazyLoadingMode(perPageVal)

  return {
    isLazyMode,
    perPageVal,
    requestPerPage: isLazyMode ? lazyChunkSize : perPageVal,
    lazyChunkSize
  }
}

/**
 * @param {{ isLazyLoadingMode?: boolean, pagination?: { activePage?: number, pages?: number } } | null | undefined} state
 * @returns {boolean}
 */
export function canBehaviourTableLoadMoreLazy(state) {
  if (!state?.isLazyLoadingMode) return false
  const currentPage = Number(state.pagination?.activePage) || 1
  const totalPages = Number(state.pagination?.pages) || 1
  return currentPage < totalPages
}

/**
 * @param {{
 *   state: Record<string, unknown>,
 *   rows: unknown[],
 *   pagination: Record<string, unknown>,
 *   perPageLabel: string,
 *   perPageVal: number,
 *   isLazyMode: boolean,
 *   append?: boolean,
 *   rowsKey?: string
 * }} args
 * @returns {{ rows: unknown[], isLazyMode: boolean }}
 */
export function applyBehaviourTableFetchResult({
  state,
  rows,
  pagination,
  perPageLabel,
  perPageVal,
  isLazyMode,
  append = false,
  rowsKey = "tableRows"
}) {
  const lazyChunkSize = behaviourConstants.CORE_VALUE_TABLE_ALL_ENTRIES_PER_PAGE

  state.isLazyLoadingMode = isLazyMode
  state.pagination = buildPaginationFromApiResponse(pagination, {
    perPageLabel,
    perPageValue: isLazyMode ? lazyChunkSize : perPageVal
  })
  state.pagination.per_page = { label: perPageLabel, value: perPageVal }

  const existingRows = Array.isArray(state[rowsKey]) ? state[rowsKey] : []
  const nextRows = rows || []

  if (isLazyMode && append) {
    state[rowsKey] = [...existingRows, ...nextRows]
    state.lazyLoadedCount = state[rowsKey].length
  } else {
    state[rowsKey] = nextRows
    state.lazyLoadedCount = nextRows.length
  }

  return { rows: nextRows, isLazyMode }
}
